import { LAYOUT_TYPE_BLANK } from "constants/theme.constant";
import React from "react";

const corporationRoute = [
  {
    key: "welcome",
    path: `/welcome`,
    component: React.lazy(() => import("views/landing/Welcome")),
    authority: [],
  },
  {
    key: "project-selection",
    path: `/project-selection`,
    component: React.lazy(() => import("views/landing/ProjectSelection")),
    authority: [],
  },
  {
    key: "privacy",
    path: `/privacy`,
    component: React.lazy(() => import("views/corporation/privacy")),
    authority: [],
  },
  {
    key: "waste-confirm",
    path: `/waste/confirm`,
    component: React.lazy(() => import("views/landing/WasteConfirm")),
    meta: { layout: LAYOUT_TYPE_BLANK },
    authority: [],
  },
];

export default corporationRoute;
